import { Observable } from 'rxjs';

import { RestfulApiService } from './restful-api.service';
import { MatchedTuple } from '../model/matched-tuple';
import { SeamRequest } from '../model/seam-request';

class SeamTupleService extends RestfulApiService<MatchedTuple, SeamRequest> {
    public exportTuples(request: SeamRequest): Observable<void> {
        return this.http.post(`${this.getUrl(request)}/export`);
    }

    public downloadTuples(request: SeamRequest): Observable<{ url: string }> {
        return this.http.post<{ url: string }>(`${this.getUrl(request)}/download`);
    }

    protected getFormName(): string {
        return 'seam_tuple';
    }

    protected getPath(parent: SeamRequest | undefined): string {
        if (undefined === parent) {
            throw new Error('You must provide parent');
        }

        return `seam-workflows/${parent.id}/tuples`;
    }
}

export const seamTupleService = new SeamTupleService();
